import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {
			width: "100%",
			display: "flex",
			alignItems: "flex-start",
			flexDirection: "row",
			paddingTop: "40px",
			marginBottom: "40px",
			marginLeft: "200px",
			position: "relative",
			"&:after": {
				position: "absolute",
				content: "''",
				left: 0,
				width: "1000%",
				top: 0,
				height: "1px",
				backgroundColor: theme.palette.colors.disabled,
			},
		},
		info: {
			width: "180px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			position: "relative",
		},
		infoLogo: {
			display: "flex",
			backgroundColor: "transparent",
			width: "80px",
			height: "80px",
			border: `1px solid ${theme.palette.colors.superLightGrey}`,
			borderRadius: "50%",
			justifyContent: "center",
			alignItems: "center",
			marginBottom: "14px",
			overflow: "hidden",
			flexShrink: 0,
		},
		infoLogoImage: {
			width: "100%",
			height: "auto",
			objectFit: "scale-down",
		},
		infoLogoImageWithSmile: {
			width: "36px",
		},
		infoWrapper: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			width: "100%",
		},
		infoName: {
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			lineHeight: "1.25",
			color: theme.palette.colors.darkSlateBlue,
			marginBottom: "1px",
			textAlign: "center",
		},
		infoStatus: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.14",
			textAlign: "center",
			color: theme.palette.colors.veryBlackGrey,
			marginTop: "2px",
			marginBottom: "17px",
		},
		infoProvider: {
			marginBottom: 0,
		},
		infoProviderName: {
			fontFamily: theme.fonts.bold,
			fontSize: "14px",
			lineHeight: "1.29",
			letterSpacing: "2px",
			color: theme.palette.colors.purplishBlue,
			marginRight: "2px",
		},
		infoDate: {
			textAlign: "center",
		},
		infoDateValue: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.29",
			color: theme.palette.colors.veryBlackGrey,
			marginBottom: "2px",
		},
		bodyWrapper: {
			position: "relative",
		},
		body: {
			width: "600px",
			padding: "25px 30px 0",
			borderRadius: "20px 0 20px 20px",
			position: "relative",
			backgroundColor: "transparent",
		},
		bodyHeader: {
			fontFamily: theme.fonts.bold,
			fontSize: "24px",
			color: theme.palette.colors.darkSlateBlue,
			lineHeight: 1,
		},
		bodyText: {
			fontFamily: theme.fonts.light,
			fontSize: "15px",
			color: theme.palette.colors.darkSlateBlue,
			marginTop: "14px",
			whiteSpace: "pre-line",
			marginBottom: 0,
		},
		isStub: {
			"& $infoLogo": {
				backgroundColor: theme.palette.colors.disabled,
			},
			"& $body": {
				backgroundColor: theme.palette.colors.disabled,
				height: "200px",
				borderRadius: "10px",
				"&:before,&:after": {
					display: "none",
				},
			},
			"& $infoName": {
				backgroundColor: theme.palette.colors.disabled,
				height: "16px",
				borderRadius: "10px",
				width: "100%",
			},
			"& $infoDate": {
				backgroundColor: theme.palette.colors.disabled,
				height: "16px",
				borderRadius: "10px",
				width: "100%",
			},
		},
		idWrapper: {
			textAlign: "right",
			fontSize: "14px",
			fontFamily: theme.fonts.medium,
			color: theme.palette.colors.cloudyBlue,
			marginTop: "16px",
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			root: {
				marginLeft: "160px",
			},
			info: {
				width: "140px",
			},
			body: {
				width: "640px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				marginLeft: "90px",
			},
			bodyWrapper: {
				width: "100%",
				flexShrink: 100,
			},
			info: {
				width: "140px",
			},
			body: {
				width: "100%",
			},
			bodyHeader: {
				fontSize: "18px",
			},
			bodyText: {
				fontSize: "15px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				width: "100%",
				display: "flex",
				marginTop: 0,
				flexWrap: "wrap",
				marginBottom: "16px",
				marginLeft: "8.33%",
				paddingTop: "16px",
			},
			info: {
				width: "100%",
				flexDirection: "row-reverse",
				alignItems: "flex-start",
				position: "relative",
				marginLeft: 0,
				marginTop: "0",
			},
			infoLogo: {
				display: "flex",
				backgroundColor: theme.palette.colors.transparent,
				height: "auto",
				border: "none",
				borderRadius: 0,
				justifyContent: "flex-end",
				alignItems: "flex-start",
				marginBottom: 0,
				marginLeft: "18px",
				width: "auto",
			},
			infoLogoImage: {
				maxWidth: "60px",
				maxHeight: "60px",
			},
			infoWrapper: {
				display: "flex",
				flexDirection: "column",
				alignItems: "flex-end",
				justifyContent: "flex-start",
				marginTop: "-5px",
			},
			infoName: {
				marginBottom: 0,
			},
			infoProvider: {
				marginBottom: "2px",
				order: 2,
			},
			infoProviderName: {
				marginRight: 0,
			},
			infoStatus: {
				marginBottom: "5px",
			},
			infoDate: {
				textAlign: "right",
				marginBottom: 0,
				order: 3,
			},
			infoDateValue: {
				marginBottom: 0,
			},
			bodyWrapper: {
				position: "relative",
				width: "100%",
			},
			body: {
				width: "100%",
				borderRadius: "20px 20px 0 20px",
				padding: "25px 8.33% 0 0",
			},
			bodyHeader: {
				display: "none",
			},
			bodyText: {
				fontSize: "14px",
				margin: 0,
			},
			idWrapper: {
				display: "none",
			},
		},
	};
};

const ReviewItemBReply = (props) => {
	let classes = props.classes;
	let text = props.textConst;
	let name = !!props.name ? props.name : text.UNKNOWN_GUEST;

	return (
		<div
			className={classNames(classes.root, {
				[classes.isStub]: props.stub,
			})}
		>
			<div className={classes.info}>
				<div className={classes.infoLogo}>
					{!props.stub && !!props.logo && (
						<picture>
							<source
								type="image/webp"
								srcSet={!!props.webpTransformer ? props.webpTransformer(props.logo) : props.logo}
							/>
							<source srcSet={props.logo} />
							<img
								alt={"reviewReplySmile"}
								className={classNames(classes.infoLogoImage, {
									[classes.infoLogoImageWithSmile]: props.logoSmile,
								})}
								src={props.logo}
							/>
						</picture>
					)}
					{props.stub && <div className={classes.infoLogoImage} />}
				</div>
				<div className={classes.infoWrapper}>
					<div className={classes.infoName}>{!props.stub && name}</div>
					<div className={classes.infoStatus}>{props.status}</div>
					<div className={classes.infoDate}>
						<div className={classes.infoDateValue}>{!props.stub && props.date}</div>
					</div>
				</div>
			</div>
			<div className={classes.bodyWrapper}>
				<div
					className={classNames(classes.body, {
						[classes.bodyIsShort]: props.short,
					})}
				>
					<div className={classes.bodyHeader}>{props.header}</div>
					<pre className={classes.bodyText}>{props.text}</pre>
					{<div className={classes.idWrapper}>{props.id}</div>}
				</div>
			</div>
		</div>
	);
};

export default withStyles(styles)(ReviewItemBReply);

export { ReviewItemBReply as __ReviewItemBReply };
